import React, { useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  Grid,
  Modal,
  TextField,
} from '@material-ui/core'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import swal from 'sweetalert'
import { insertTechnicalAssistanceReceived } from '../../../../../services/AsistenciaTecnica/create'
import { updateTechnicalAssistanceReceived } from '../../../../../services/AsistenciaTecnica/put'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'

export const Modal17 = (props) => {
  const {
    open,
    setOpen,
    getTechnicalAssistanceReceivedList,
    body,
    setBody,
    IdTechnicalAssistanceAnswer,
  } = props

  const [loading, setLoading] = useState(false)
  const [errorEntity, setErrorEntity] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    TechnicalAssistanceTitle: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
    FundingEntity: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdTechnicalAssistanceReceived: body.IdTechnicalAssistanceReceived || 0,
      IdTechnicalAssistanceAnswer:
        body.IdTechnicalAssistanceAnswer || IdTechnicalAssistanceAnswer,
      TechnicalAssistanceTitle: body.TechnicalAssistanceTitle || '',
      FundingEntity: body.FundingEntity || '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      handleGuardar(values)
    },
  })

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('Error', error))
  }

  const handleGuardar = async (values) => {
    setLoading(true)
    let response
    if (Object.keys(body).length === 0) {
      response = await insertTechnicalAssistanceReceived(values)
    }
    if (Object.keys(body).length > 0) {
      response = await updateTechnicalAssistanceReceived(values)
    }
    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getTechnicalAssistanceReceivedList()
      handleClose()
      setLoading(false)
    }
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setBody({})
    setErrorEntity(false)
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos de la Asistencia Técnica</h1>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Título Asistencia Técnica{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  autoComplete="off"
                  inputProps={{ maxLength: 100 }}
                  value={formik.values.TechnicalAssistanceTitle}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'TechnicalAssistanceTitle',
                      e.target.value,
                    )
                  }}
                  error={formik.errors.TechnicalAssistanceTitle}
                />
                {formik.errors.TechnicalAssistanceTitle ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.TechnicalAssistanceTitle}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Ente Financiador <span style={{ color: 'red' }}>*</span>
              </label>
              <a
                data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje."
                data-for="infoCurrencyPop"
                style={{ cursor: 'pointer' }}
              >
                <ErrorOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoCurrencyPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  autoComplete="off"
                  value={formik.values.FundingEntity}
                  onChange={(e) => {
                    if (
                      e.target.value.match(
                        /[-:.;,%#()\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                      ) ||
                      e.target.value === ''
                    ) {
                      setErrorEntity(false)
                      formik.setFieldValue('FundingEntity', e.target.value)
                    } else {
                      setErrorEntity(true)
                    }
                  }}
                  inputProps={{ maxLength: 100 }}
                  error={formik.errors.FundingEntity}
                />
                {errorEntity ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    Caracteres especiales no aceptados
                  </div>
                ) : null}
                {formik.errors.FundingEntity ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.FundingEntity}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid className="buttonsPYME">
              <Button className="cancelButton" onClick={handleClose}>
                Cancelar
              </Button>
              <Button
                className="confirmButton"
                type="button"
                onClick={validateFormStatus}
                disabled={loading}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
